// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"474ed1bb","77":"e6dc69a5","274":"927ee464","295":"6e5dff65","466":"0e39fe71","589":"c4cde16b","620":"b5331eb0","642":"be87b4a3","671":"9c7a1f17","773":"d085aab1","783":"d1d41c59","969":"57b51308"}[chunkId] + ".chunk.js";
};